import Core from "@/modules/core/service/Core";

const url = {
    images: "/api/disposition/{0}/image?type={1}",
}

export default {
    findByType (inspectionId, type) {
        return Core.method.get(url.images, inspectionId, type);
    },

    getImageUrl (inspectionId, imageId) {
        return "/api/disposition/" + inspectionId + "/image/" + imageId;
    }
}